import React from 'react';
import { CommonSummaryInfoSubtitle } from 'src/components/EntityPage/CommonSummaryInfo/CommonSummaryInfo';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import TotalTrafficGrid from '../TotalTrafficGrid';
import { PercentTotalTrafficSplineChart } from '../PercentTotalTrafficSplineChart';
import { TrafficBarChartForTopics } from '../TrafficBarChartForTopics';
import { TrafficSplineChartForTopics } from '../TrafficSplineChartForTopics';
import { TotalTrafficTopSectionForTopics } from '../TotalTrafficTopSectionForTopics';
import { KeywordCountForTopics } from '../KeywordCountForTopics';
import { TrafficByTopicBarChart } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/TrafficByTopicBarChart';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

/**
 * Total traffic page for topic or topic group entities
 */
export const TopicOrTopicGroupPage = () => {
  const mainEntityType = useMainEntityType();
  const isTopic = mainEntityType === 'topic';
  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <Flex gap="lg" flexDirection="column">
          <CommonSummaryInfoSubtitle title="Total Traffic" />
          <TotalTrafficTopSectionForTopics />
        </Flex>
        <TrafficSplineChartForTopics trafficType="totalTraffic" />
        {!isTopic && <TrafficByTopicBarChart metric="totalTraffic" />}
        <TrafficBarChartForTopics trafficType="totalTraffic" />
        <KeywordCountForTopics keywordType="totalTrafficKeywordCount" />
        <PercentTotalTrafficSplineChart trafficType="totalTraffic" />
        <TotalTrafficGrid />
      </Flex>
    </BasePageContainer>
  );
};
